import { useAuth } from '../context/AuthContext';

export const usePermissions = () => {
  const { user, permissions } = useAuth();

  const userRoles = user?.roles || (user?.role ? [user.role] : []);
  const isSuperAdmin = userRoles.includes('super_admin');
  const isPilot = userRoles.includes('admin') || isSuperAdmin;

  // Vérifier une permission dans un module spécifique
  const hasModulePermission = (module, permission) => {
    if (isSuperAdmin) return true;
    if (isPilot) {
      return permissions?.[module]?.[permission] === true;
    }
    return false;
  };

  const canAccessCommunications = () => hasModulePermission('communications', 'access');
  const canAccessBlog = () => hasModulePermission('actualites', 'access');
  const canAccessAdherents = () => hasModulePermission('adhesions', 'access');
  const canAccessUsers = () => hasModulePermission('users', 'access');
  const canSendPaymentLink = () => hasModulePermission('adhesions', 'sendPaymentLink');
  const canChangeAdherentStatus = () => hasModulePermission('adhesions', 'changeAdherentStatus');
  const canAccessUnafServices = () => hasModulePermission('unafServices', 'access');
  const canGenerateUnafExport = () => hasModulePermission('unafServices', 'generateExport');
  const canSendUnafExport = () => hasModulePermission('unafServices', 'sendExport');
  const canActivateUnafExport = () => hasModulePermission('unafServices', 'activateExport');
  const canPayUnafExport = () => hasModulePermission('unafServices', 'payExport');
  const canDeleteUnafExport = () => hasModulePermission('unafServices', 'deleteExport');

  // Module Événements
  const canAccessEvents = () => hasModulePermission('evenements', 'access');
  const canCreateEvent = () => hasModulePermission('evenements', 'createEvent');
  const canManageVolunteers = () => hasModulePermission('evenements', 'manageVolunteers');
  const canUploadEventDocuments = () => hasModulePermission('evenements', 'uploadDocuments');
  const canAccessMiellerie = () => hasModulePermission('miellerie', 'access');
  const canManageMiellerieResponsables = () => hasModulePermission('miellerie', 'manageResponsables');
  const canExportMiellerieResponsableStats = () => hasModulePermission('miellerie', 'exportResponsableStats');
  const canManageMiellerieActivite = () => hasModulePermission('miellerie', 'manageActivite');

  return {
    hasModulePermission,
    isPilot,
    isSuperAdmin,
    canAccessCommunications,
    canAccessBlog,
    canAccessAdherents,
    canAccessUsers,
    canSendPaymentLink,
    canChangeAdherentStatus,
    canAccessUnafServices,
    canGenerateUnafExport,
    canSendUnafExport,
    canActivateUnafExport,
    canPayUnafExport,
    canDeleteUnafExport,
    canAccessEvents,
    canCreateEvent,
    canManageVolunteers,
    canUploadEventDocuments,
    canAccessMiellerie,
    canManageMiellerieResponsables,
    canExportMiellerieResponsableStats,
    canManageMiellerieActivite,
    permissions,
  };
};
